import { render, staticRenderFns } from "./YouAge.vue?vue&type=template&id=0a610b6c"
import script from "./YouAge.vue?vue&type=script&lang=js"
export * from "./YouAge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports